// extracted by mini-css-extract-plugin
export default {"required":"Shipping_required__7buRW"};